module.exports = __webpack_public_path__ + "img/20.dc0b9797.png";